import React, { ReactNode } from 'react';

interface WorkspaceEmptyStateProps {
  message: string;
  children?: ReactNode;
}

// Single source of truth for the centre-workspace "instruction" pattern:
// the #E5E9EC fill, the message's max width/alignment/typography, always
// vertically centered. Any future styling change to this pattern belongs
// here, not in each call site.
const WorkspaceEmptyState: React.FC<WorkspaceEmptyStateProps> = ({
  message,
  children,
}) => (
  <div className="flex flex-1 flex-col items-center justify-center gap-3 bg-gray-bright">
    <div className="flex w-full max-w-sm flex-col gap-3">
      <span className="text-center text-sm font-semibold leading-snug text-gray-dark">
        {message}
      </span>
      {children}
    </div>
  </div>
);

export default WorkspaceEmptyState;
